<template lang="pug">
.order-container.fix(:class="{ 'page-break': pageBreak }" :style="{ width, height }")
  div
    .container-header(v-if="!order.isDropshipping")
      img.logo(:src="`${imagePath}/others/print-return-${order.brand}.png`")
      //.sender-info-container
        .sender-info.capitalize {{ data[order.brand].name  }} - {{ data[order.brand].documentNumber }}
        .sender-info.capitalize {{ data[order.brand].address }} - {{ data[order.brand].phone }}

    .container-zimple(v-else)
      img.logo-zimple(:src="`${imagePath}/others/logo-zimple.png`")
      .sender-info-container
        .sender-info Zimple Life SAS
        .sender-info 901.524.561-8
        .sender-info Calle 37B Sur #28c 01
        .sender-info 3245452675

    .order-info
      .qr-container
        QRCode(:text="order.order" width="60")
      .info-principal
        //img.order-conveyor(v-if="order.conveyor && (order.conveyor !== 'sahet' && order.conveyor !== 'bassica')" :src="`${imagePath}/conveyors/${order.conveyor}.png`")
        .order.uppercase {{ order.order }}
        .order-location.capitalize.no-wrap {{ locationLabel }}
        .cod-delivery(v-if="order.methodPay === 'cod' || order.cod") Cobrar Paquete: {{ money(total) }}
        .cod-delivery(v-if="(order.methodPay === 'dropshipping' || order.isWholesaler) && order.userPayConveyor") Envío al Cobro

    .buyer-info
      .buyer-name.capitalize
        span.dark Nombre:
        span  {{ buyerRemit.name }}
      .buyer-phones
        span.dark Tel:
        span  {{ buyerRemit.phones.join(', ') }}
      .buyer-address.capitalize
        span.dark Dir:
        span.uppercase  {{ buyerRemit.address }}

      .buyer-address.capitalize(v-if="observationsDelivery.length")
        span.dark Importante:
        span(v-for="observation in observationsDelivery")  {{ observation.observation }}.

    div(v-if="order.isDropshipping")
      .wait(v-if="!order.userPayConveyor || order.cod") Esperar Remite...

    .gift-tape(v-if="order.isGift")
      img.gift-tape-image(:src="require('@/assets/gift-tape.png')")

  .order-side-label
    .order-side-label-text
      span.order-side-label-name(v-if="sideName") {{ sideName }}
      span.order-side-label-number {{ sideNumber }}
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'
import { getBuyerRemitFromOrder } from '@/helpers/remit'

export default {
  name: 'OrderPrintReturnAddress',

  mixins: [mForm, mFilters],

  components: { QRCode },

  props: {
    order: Object,
    pageBreak: Boolean,
    remitOnly: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '10cm'
    },
    height: {
      type: String,
      default: '10cm'
    }
  },

  data () {
    return {
      deliverySchedule: {
        '8-21': '🌞 8:00 a.m. - 🌚 9:00 p.m.',
        '8-20': '🌞 8:00 a.m. - 🌛 8:00 p.m.',
        '8-13': '🌞 8:00 a.m. - 😎 1:00 p.m.',
        '13-20': '😎 1:00 p.m. - 🌛 8:00 p.m.',
        '13-21': '😎 1:00 p.m. - 🌚 9:00 p.m.'
      }
    }
  },

  computed: {
    total () {
      return this.order.total || 0
    },

    data () {
      return this.$store.state.variables.data
    },

    quantitySale () {
      return 3
    },
    observationsDelivery () {
      if (!this.order.observations.length) return []
      return this.order.observations.filter(observation => observation.type === 'delivery')
    },

    buyerRemit () {
      return getBuyerRemitFromOrder(this.order, { remitOnly: this.remitOnly })
    },

    sideNumber () {
      const orderId = String(this.order.order || '')
      return orderId.replace(/\D/g, '').slice(-3) || orderId.slice(-3)
    },

    sideName () {
      const firstName = (this.buyerRemit.name || '').trim().split(/\s+/)[0] || ''
      return firstName.slice(0, 8)
    },

    locationLabel () {
      const location = (this.buyerRemit.location || '').trim()
      const department = (this.buyerRemit.department || '').trim()

      if (!department || location.toLowerCase() === department.toLowerCase()) return location

      return `${location} - ${department}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-container
  background-color white
  color black
  display flex
  padding 3mm calc(3mm + 14mm) 3mm 3mm
  vertical-align top
  border 1px dashed black
  border-radius 3mm
  margin 0 3mm 3mm 3mm
  align-items center
  position relative
  overflow hidden

.container-header
  display flex
  align-items center

.logo
  height 4mm
  display block
  margin-bottom 1mm

.sender-info-container
  border-left .5mm solid black
  padding-left 2mm
  margin-left 2mm

.sender-info
  font-size 3mm

.order-info
  display flex
  align-items center

.order
  font-size 6mm
  font-weight 600

.order-conveyor
  height 4mm
  width auto
  filter brightness(0)

.order-location
  font-size 4mm
  font-weight 600

.order-total
  font-size 3mm
  margin-top 4mm
  font-weight 600
  text-decoration underline

.order-observations
  margin-top 4mm
  font-size 3.5mm
  list-style-type upper-alpha

.order-observation
  padding 0em 0 0em 1em

.order-observation > li
  list-style decimal

.buyer-name, .buyer-phones, .buyer-address, .buyer-dni
  font-size 3mm

.fix
  page-break-inside avoid

.cod-delivery
  font-size 3mm
  border-bottom 1mm solid black
  display inline-block
  padding .2mm 0
  font-weight 600

.wait
  font-size 4mm
  text-decoration underline
  font-weight 600

.container-zimple
  display flex
  gap 2mm

.page-break
  break-inside avoid

.gift-tape
  position absolute
  top 0
  right 0
  width 35mm
  height 1mm
  background-color #6d0010
  transform rotate(45deg) translateX(7.5mm) translateY(-14mm)
  transform-origin 0 0
  display flex
  align-items center
  justify-content center

.gift-tape-image
  width 4rem
  margin-top 2mm

.order-side-label
  position absolute
  right 3mm
  top 0
  bottom 0
  width 14mm
  display flex
  align-items center
  justify-content center
  pointer-events none

.order-side-label-text
  display flex
  flex-direction column
  align-items center
  gap 0.6mm
  transform rotate(-90deg)
  white-space nowrap
  line-height 1
  text-transform uppercase

.order-side-label-name
  font-size 5mm
  font-weight 700
  letter-spacing .3mm

.order-side-label-number
  font-size 7mm
  font-weight 800
  letter-spacing .4mm

@media print
  .order-container
    border none
    margin 0
    border-top .5mm solid black
    border-radius 0
</style>



// WEBPACK FOOTER //
// src/components/pages/print/OrderPrintReturnAddress.vue